module.exports = __webpack_public_path__ + "static/media/training2.17d0229a.png";